<template>
  <div class="informasi_pendaftaran_free">
    <SOSlotBase
      :container-name="`informasi_pendaftaran_succses`"
      :loading="isLoading"
    >
      <template v-slot:title-bar>
        <SOTitleBar :page-title="'Ulasan Anda'" :type="'back'" @back="back" />
      </template>
      <template v-slot:loading-page>
        <SOLoadingPage />
      </template>
      <template v-slot:content>
        <div class="p-t-16 p-x-20 bg-white">
          <div class="pertanyaan1 p-t-16 f-c-black">
            <p class="f-14 f-Overpass">
              1. Apakah penjelasan trainer informatif bagi user?
            </p>
          </div>
          <div class="bintang">
            <star-rating
              v-model="rating1"
              :show-rating="false"
              :star-size="20"
              :padding="30"
              style="width: max-content"
              id="bintang"
            ></star-rating>
          </div>
          <div class="p-t-16 d-flex-between-center">
            <div class="f-regular f-12 f-c-black">Tidak Membantu</div>
            <div class="f-regular f-12 f-c-black">Sangat Membantu</div>
          </div>

          <div class="pertanyaan2 p-t-24 f-c-black d-flex">
            <div><p class="f-14 f-Overpass">2.</p></div>
            <div>
              <p class="f-14 f-Overpass" style="margin-left: 1mm">
                Apakah penjelasan trainer sesuai dengan kebutuhan user?
              </p>
            </div>
          </div>
          <div class="bintang">
            <star-rating
              v-model="rating2"
              :show-rating="false"
              :star-size="20"
              :padding="30"
              style="width: max-content"
              id="bintang"
            ></star-rating>
          </div>

          <div class="p-t-16 d-flex-between-center">
            <div class="f-regular f-12 f-c-black">Tidak Membantu</div>
            <div class="f-regular f-12 f-c-black">Sangat Membantu</div>
          </div>

          <div class="pertanyaan2 p-t-24 f-c-black d-flex">
            <div><p class="f-14 f-Overpass">3.</p></div>
            <div>
              <p class="f-14 f-Overpass" style="margin-left: 1mm">
                Bagaimana menurut Anda atas solusi yang diberikan trainer untuk
                pertanyaan anda?
              </p>
            </div>
          </div>
          <textarea
            class="form-control f-16 f-c-black f-Overpass"
            id="id"
            placeholder="Masukan Ulasan Anda"
            maxlength="150"
            rows="4"
            required
          ></textarea>

          <div class="pertanyaan2 p-t-24 f-c-black d-flex">
            <div><p class="f-14 f-Overpass">4.</p></div>
            <div>
              <p class="f-14 f-Overpass" style="margin-left: 1mm">
                Kritik dan saran Anda terhadap aplikasi kami?
              </p>
            </div>
          </div>
          <textarea
            class="form-control f-16 f-c-black f-Overpass"
            id="id"
            placeholder="Masukan Ulasan Anda"
            maxlength="150"
            rows="4"
            required
          ></textarea>
          <div class="btn_ulasan p-t-12">
            <button
              type="button"
              class="btn btn-login btn-long"
              @click="routeToSubmit"
              id="buttonulasan"
              style="width: 100%"
            >
              Submit Ulasan
            </button>
          </div>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOInputTextarea from "@/so-components/global/input/SOInputTextarea";
import StarRating from "vue-star-rating";

export default {
  name: "ulasan",
  components: {
    SOTitleBar: SOTitleBar,
    SOSlotBase: SOSlotBase,
    SOLoadingPage: SOLoadingPage,
    SOInputTextarea: SOInputTextarea,
    StarRating,
  },
  data() {
    return {
      isLoading: false,
      rating1: null,
      rating2: null,
    };
  },

  methods: {
    routeToSubmit() {
      this.$router.push({ name: "trainingWithTraining" });
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
#Detail {
  font-family: Overpass;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
  margin-left: 20px;
  margin-top: 10px;
}

.btn_kembali {
  display: flex;
  justify-content: center;
  margin-top: 8%;
}

.btn_ulasan {
  display: flex;
  justify-content: center;
}
#buttonulasan {
  width: 100%;
  font-weight: 600;
}

.bintang {
  display: flex;
  justify-content: flex-end;
}
@media (min-width: 320px) and (max-width: 768px) {
  .btn_kembali {
    display: flex;
    justify-content: center;
    margin-top: 20%;
  }
}

@media (min-width: 375px) {
  .bintang {
    display: flex;
    justify-content: center;
  }
}
</style>
